import React, { SyntheticEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { TextInput, Dropdown } from 'components'
import { IconSearch, IconClose } from 'components/Icons'

import { STATUS_OPTIONS } from 'helpers/constants/common'
import { findSelected, onEnter } from 'helpers/common'
import { useSearchParams } from 'helpers/hooks'

import type { OptionProps } from 'types'

interface propsStockKeepingUnitSearch {
  isLoading: boolean
}

function StockKeepingUnitSearchAndFilter(
  props: propsStockKeepingUnitSearch,
): JSX.Element {
  const { isLoading } = props
  const [searchParams, setSearchParams] = useSearchParams()

  const q: string = searchParams?.q || ''
  const [search, setSearch] = useState<string>(q)
  const { t } = useTranslation('sku')

  const base = 'f-stock-keeping-unit-row'

  const selected =
    findSelected(STATUS_OPTIONS, searchParams?.isActive) || STATUS_OPTIONS[1]

  const handleStatusChange = (status: OptionProps): void => {
    const nextStatus = status.key
    setSearchParams({ isActive: nextStatus, _page: 1 })
  }

  const _handleChange = (e: SyntheticEvent) => {
    e.preventDefault()

    const target = e.target as HTMLInputElement

    setSearch(target.value)
  }

  const handleClear = (): void => {
    setSearchParams({ q: '', _page: 1 })
    setSearch('')
  }

  const handleSubmit = (): void => {
    setSearchParams({ q: search.trim(), _page: 1 })
  }

  return (
    <div className={base}>
      <TextInput
        showIcon={isLoading}
        isLoading={isLoading}
        disabled={isLoading}
        placeholder={t('searchList.placeholder')}
        variants='secondary'
        name='search'
        onChange={_handleChange}
        value={search}
        onKeyDown={onEnter(handleSubmit)}
        withIcon={
          q && q === search ? (
            <span className='f-company-row__btn-search' onClick={handleClear}>
              <IconClose variants='sm' />
            </span>
          ) : (
            <span className='f-company-row__btn-search' onClick={handleSubmit}>
              <IconSearch variants='sm' />
            </span>
          )
        }
      />
      <Dropdown
        options={STATUS_OPTIONS}
        variants='secondary'
        selected={selected}
        onChange={(item) => handleStatusChange(item)}
        label='sku:skuStatus.placeholder'
      />
    </div>
  )
}

export default StockKeepingUnitSearchAndFilter
